import Input from "../../../utils/components/Input";
import Button from "../../../utils/components/Button";
import { useState } from "react";
import getLocation from "../../../utils/helpers/getLocation";
import { Translate } from "react-localize-redux";

const LatLngMap = ({
  lat,
  lng,
  read_only,
  onChange,
  hidden,
  required,
  userLocation,
}) => {
  const [gettingLocation, setGettingLocation] = useState(false);

  const handleGetLocation = () => {
    setGettingLocation(true);
    if (userLocation) {
      if (onChange) onChange(userLocation);

      setGettingLocation(false);
    } else {
      getLocation((location) => {
        if (onChange) onChange(location);

        setGettingLocation(false);
      });
    }
  };

  return (
    <>
      <Input
        value={lat && lng ? `Latitude: ${lat}, Longitude: ${lng}` : ""}
        disabled={read_only}
        // onChange={(e) => setLocation(e.target.value)}
        inputProps={{
          required,
          readOnly: userLocation?.lat && userLocation?.lng ? true : false,
        }}
      />
      <Button
        className="btn fs-6 mt-2"
        onClick={handleGetLocation}
        disabled={gettingLocation}
      >
        <Translate id={gettingLocation ? "loading" : "forms.get_location"} />
      </Button>
    </>
  );
};

export default LatLngMap;
